Revolution.Module.extend({
    NAME: "mde.edito", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        // _.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        if ($('.wysiwyg-header').length) {
            this.dataHeightTitle();
        }
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
    },
    dataHeightTitle: function (e) {
        var wHeight = $('.wysiwyg-header').height();
        $('.spacer-menu-sm').height(wHeight);
    }
});
